// components
import {
  Box,
  Chip,
  Divider,
  List,
  ListItem,
  styled,
  Typography
} from '@mui/material';
import { IconButton } from '@sdb/planning-ui';

// types
import { AuditedCommandChangeEventDetailsResponse } from 'generated/index';

export const LogEntriesContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  overflowY: 'auto'
}));

export const LogEntryContainer = styled(Box)<{ isUndone?: boolean }>(
  ({ theme, isUndone }) => ({
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(2),
    backgroundColor: theme.vars.palette.surface.containerLow,
    borderRadius: theme.vars.shape.borderRadius,
    opacity: isUndone ? 0.6 : 1
  })
);

export const MetaContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  marginBottom: theme.spacing(2)
}));

export const LeftContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  flexDirection: 'column',
  gap: theme.spacing(0.5),
  width: '100%'
}));

export const LogEntryLabel = styled(Chip)<{
  type: AuditedCommandChangeEventDetailsResponse['type'];
  isUndone?: boolean;
}>(({ theme, isUndone }) => ({
  width: 'min-content',
  height: theme.spacing(4),
  backgroundColor: theme.vars.palette.surface.containerHigh,
  color: theme.vars.palette.grey['700'],
  textDecoration: isUndone ? 'line-through' : 'none',
  '&:first-of-type': {
    marginTop: theme.spacing(2)
  }
}));

export const Metadata = styled(Typography)(({ theme }) => ({
  fontSize: '15px',
  fontWeight: 500,
  color: theme.palette.primary.main,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis'
}));

export const StyledIconButton = styled(IconButton)({
  width: '16px',
  height: '16px',
  '> svg': {
    width: '16px',
    height: '16px'
  }
});

export const ChangeLogContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  transitionDuration: `${theme.transitions.duration.short}ms`
}));

export const ChangeLogContentDivider = styled(Divider)(({ theme }) => ({
  backgroundColor: theme.vars.palette.grey['50']
}));

export const ChangeLogList = styled(List)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(4)
}));

export const ChangeLogListItem = styled(ListItem)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),
  '&:first-of-child': {
    marginTop: theme.spacing(8)
  }
}));

export const ChangeLogChip = styled(Chip)<{ type: 'new' | 'old' }>(
  ({ theme, type }) => ({
    backgroundColor: theme.vars.palette.surface.containerHigh,
    textDecoration: type === 'old' ? 'line-through' : 'inherit'
  })
);

export const InfoSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1.5)
}));

export const InfoRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1.5)
}));

export const IconWrapper = styled(Box)<{ iconColor?: string }>(
  ({ theme, iconColor }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '20px',
    height: '20px',
    color: iconColor || theme.palette.primary.main,
    '& svg': {
      width: '16px',
      height: '16px'
    }
  })
);

export const InfoLabel = styled(Typography)(({ theme }) => ({
  fontSize: '13px',
  lineHeight: 1.4,
  color: theme.palette.text.primary,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
}));
